import React__default from 'react';
import { CommonStyles } from '../BaseProps/index.es.js';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function thoundsandDelimiter(value) {
  if (!value) {
    return "0";
  } else {
    const valueInNumber = typeof value === "number" ? value : parseInt(value);
    if (isNaN(valueInNumber)) {
      return "";
    } else {
      return valueInNumber.toLocaleString("de-DE", { maximumFractionDigits: 2 }).toString();
    }
  }
}
const FONT_WEIGHT_MAP = {
  bold: 700,
  medium: 500,
  regular: 400
};
const StyledCurrency = styled.span`
  ${CommonStyles}
  width: max-content;
  display: inline-block;
  color: ${(p) => p.theme.colors[p.color] || p.color || "inherit"};
  font-weight: ${(p) => p.weight ? FONT_WEIGHT_MAP[p.weight] : "inherit"};
`;
const formatCurrency = (value, {
  hideCurrencySymbol,
  space,
  underline,
  currencyLabel
}) => {
  const formatted = thoundsandDelimiter(value);
  return hideCurrencySymbol ? formatted : `${formatted}${space ? " " : ""}${currencyLabel || (underline ? "\u20AB" : "\u0111")}`;
};
const Currency = (_a) => {
  var _b = _a, {
    value,
    formattedValue,
    hideCurrency = false,
    space = false,
    underline = false,
    currencyLabel
  } = _b, props = __objRest(_b, [
    "value",
    "formattedValue",
    "hideCurrency",
    "space",
    "underline",
    "currencyLabel"
  ]);
  if (!!formattedValue) {
    return /* @__PURE__ */ React__default.createElement(StyledCurrency, __spreadValues({}, props), hideCurrency ? formattedValue : `${formattedValue}${space ? " " : ""}${currencyLabel || (underline ? "\u20AB" : "\u0111")}`);
  }
  if (value === 0 || !!value) {
    return /* @__PURE__ */ React__default.createElement(StyledCurrency, __spreadValues({}, props), formatCurrency(value, {
      space,
      underline,
      hideCurrencySymbol: hideCurrency,
      currencyLabel
    }));
  }
  return /* @__PURE__ */ React__default.createElement(StyledCurrency, __spreadValues({}, props), "\xA0");
};

export { Currency, formatCurrency, thoundsandDelimiter };
